import { HttpContextToken } from "@angular/common/http";

export const DISABLE_AUTH_HANDLE = new HttpContextToken<boolean | null | ((error: unknown) => boolean | null)>(() => null);
